<template>
    <div class="container">
        <div class="uniform-modal-body">
            <!-- <b-row class="justify-content-center mb-3">
                <h5 class="password-policy-title">{{ labels.title }}</h5> 
            </b-row> -->

            <b-row class="mb-2 align-items-center">
                <b-col cols="12" md="4" class="text-left">
                    <label class="password-policy-item">{{ labels.activoCorriente }}</label> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input
                        v-model="form.activoCorriente"
                        type="number"
                        class="reset-input"
                        :placeholder="labels.activoCorriente"
                        step="0.01"
                    ></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mb-2 align-items-center">
                <b-col cols="12" md="4" class="text-left">
                    <label class="password-policy-item">{{ labels.activoNoCorriente }}</label> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input
                        v-model="form.activoNoCorriente"
                        type="number"
                        class="reset-input"
                        :placeholder="labels.activoNoCorriente"
                        step="0.01"
                    ></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mb-2 align-items-center">
                <b-col cols="12" md="4" class="text-left">
                    <label class="password-policy-item">{{ labels.totalActivo }}</label> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input
                        v-model="form.totalActivo"
                        type="number"
                        class="reset-input"
                        :placeholder="labels.totalActivo"
                        step="0.01"
                    ></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mb-2 align-items-center">
                <b-col cols="12" md="4" class="text-left">
                    <label class="password-policy-item">{{ labels.pasivoCorriente }}</label> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input
                        v-model="form.pasivoCorriente"
                        type="number"
                        class="reset-input"
                        :placeholder="labels.pasivoCorriente"
                        step="0.01"
                    ></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mb-2 align-items-center">
                <b-col cols="12" md="4" class="text-left">
                    <label class="password-policy-item">{{ labels.pasivoNoCorriente }}</label> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input
                        v-model="form.pasivoNoCorriente"
                        type="number"
                        class="reset-input"
                        :placeholder="labels.pasivoNoCorriente"
                        step="0.01"
                    ></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mb-2 align-items-center">
                <b-col cols="12" md="4" class="text-left">
                    <label class="password-policy-item">{{ labels.totalPasivo }}</label> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input
                        v-model="form.totalPasivo"
                        type="number"
                        class="reset-input"
                        :placeholder="labels.totalPasivo"
                        step="0.01"
                    ></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mb-2 align-items-center">
                <b-col cols="12" md="4" class="text-left">
                    <label class="password-policy-item">{{ labels.utilidadAcumulada }}</label> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input
                        v-model="form.utilidadAcumulada"
                        type="number"
                        class="reset-input"
                        :placeholder="labels.utilidadAcumulada"
                        step="0.01"
                    ></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mb-2 align-items-center">
                <b-col cols="12" md="4" class="text-left">
                    <label class="password-policy-item">{{ labels.totalPatrimonio }}</label> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input
                        v-model="form.totalPatrimonio"
                        type="number"
                        class="reset-input"
                        :placeholder="labels.totalPatrimonio"
                        step="0.01"
                    ></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mb-3 align-items-center">
                <b-col cols="12" md="4" class="text-left">
                    <label class="password-policy-item">{{ labels.ebit }}</label> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input
                        v-model="form.ebit"
                        type="number"
                        class="reset-input"
                        :placeholder="labels.ebit"
                        step="0.01"
                    ></b-form-input>
                </b-col>
            </b-row>

            <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                <b-button
                    class="reset-btn-primary"
                    @click="guardarInfoFinanciera"
                    :disabled="loading"
                >
                    
                    {{ labels.save }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import InformacionFinanciera from '../../../services/InformacionFinanciera'; 

export default {
    name: 'Modificar',
    props: {
        infoFinanciera: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            form: {
                activoCorriente: '',
                activoNoCorriente: '',
                totalActivo: '',
                pasivoCorriente: '',
                pasivoNoCorriente: '',
                totalPasivo: '',
                utilidadAcumulada: '',
                totalPatrimonio: '',
                ebit: ''
            },
            loading: false
        }
    },
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: 'Información financiera',
                    save: 'Guardar',
                    saving: 'Guardando...',
                    close: 'Cerrar',
                    vigencia: 'Vigencia',
                    activoCorriente: 'Activo corriente',
                    activoNoCorriente: 'Activo no corriente',
                    totalActivo: 'Total activo',
                    pasivoCorriente: 'Pasivo corriente',
                    pasivoNoCorriente: 'Pasivo no corriente',
                    totalPasivo: 'Total pasivo',
                    utilidadAcumulada: 'Utilidad acumulada',
                    totalPatrimonio: 'Total patrimonio',
                    ebit: 'EBIT'
                }
            } else {
                return {
                    title: 'Financial information',
                    save: 'Save',
                    saving: 'Saving...',
                    close: 'Close',
                    vigencia: 'Validity',
                    activoCorriente: 'Current assets',
                    activoNoCorriente: 'Non-current asset',
                    totalActivo: 'Total assets',
                    pasivoCorriente: 'Current liabilities',
                    pasivoNoCorriente: 'Non-current liabilities',
                    totalPasivo: 'Total liabilities',
                    utilidadAcumulada: 'Accumulated profit',
                    totalPatrimonio: 'Total equity',
                    ebit: 'EBIT'
                }
            }
        }
    },
    methods: {
        guardarInfoFinanciera() {
            // Validar campos obligatorios
            if (!this.form.activoCorriente ||
                !this.form.activoNoCorriente ||
                !this.form.totalActivo ||
                !this.form.pasivoCorriente ||
                !this.form.pasivoNoCorriente ||
                !this.form.totalPasivo ||
                !this.form.utilidadAcumulada ||
                !this.form.totalPatrimonio ||
                !this.form.ebit
            ) {
                this.$toast.error('Campo(s) pendiente(s) por diligenciar');
                return;
            }

            this.loading = true;

            const info = {
                'id': this.infoFinanciera.id,
                'vigencia': this.infoFinanciera.vigencia,
                'activoCorriente': this.form.activoCorriente,
                'activoNoCorriente': this.form.activoNoCorriente,
                'totalActivo': this.form.totalActivo,
                'pasivoCorriente': this.form.pasivoCorriente,
                'pasivoNoCorriente': this.form.pasivoNoCorriente,
                'totalPasivo': this.form.totalPasivo,
                'utilidadAcumulada': this.form.utilidadAcumulada,
                'totalPatrimonio': this.form.totalPatrimonio,
                'ebit': this.form.ebit,
                'idUser': this.$store.state.userId
            };

            InformacionFinanciera.updateInformacionFinanciera(info)
                .then((res) => {
                    this.loading = false;
                    if (res.status == 200) {
                        this.$toast.success(res.data.message);
                        this.$emit('informacion-actualizada');
                        this.loadData();
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    console.error('Error al actualizar:', err);
                    this.$toast.error('Error al actualizar la información');
                });
        },
        loadData() {
            if (this.infoFinanciera && Object.keys(this.infoFinanciera).length > 0) {
                this.form.activoCorriente = this.infoFinanciera.activo_corriente || '';
                this.form.activoNoCorriente = this.infoFinanciera.activo_no_corriente || '';
                this.form.totalActivo = this.infoFinanciera.total_activo || '';
                this.form.pasivoCorriente = this.infoFinanciera.pasivo_corriente || '';
                this.form.pasivoNoCorriente = this.infoFinanciera.pasivo_no_corriente || '';
                this.form.totalPasivo = this.infoFinanciera.total_pasivo || '';
                this.form.utilidadAcumulada = this.infoFinanciera.utilidad_acumulada || '';
                this.form.totalPatrimonio = this.infoFinanciera.total_patrimonio || '';
                this.form.ebit = this.infoFinanciera.ebit || '';
            }
        },
        resetForm() {
            this.form = {
                activoCorriente: '',
                activoNoCorriente: '',
                totalActivo: '',
                pasivoCorriente: '',
                pasivoNoCorriente: '',
                totalPasivo: '',
                utilidadAcumulada: '',
                totalPatrimonio: '',
                ebit: ''
            };
            this.loading = false;
        }
    },
    watch: {
        infoFinanciera: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (newVal && Object.keys(newVal).length > 0) {
                    this.loadData();
                }
            }
        }
    },
    mounted() {
        if (this.infoFinanciera && Object.keys(this.infoFinanciera).length > 0) {
            this.loadData();
        }
    }
}
</script>

<style scoped>
/* Estilos consistentes con el componente Crear */
.reset-input {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 6px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    background-color: #fff;
    font-size: 0.95rem;
}

.reset-input:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.reset-input:disabled {
    background-color: #e9ecef;
    opacity: 0.7;
    cursor: not-allowed;
}

.reset-input::placeholder {
    color: #6c757d;
    opacity: 0.7;
    font-size: 0.85rem;
}

.password-policy-title {
    font-weight: 600;
    color: #2c3e50;
    font-size: 1.1rem;
    margin-bottom: 0;
}

.password-policy-item {
    font-weight: 500;
    color: #495057;
    font-size: 0.95rem;
    margin-bottom: 0;
}

.uniform-modal-body {
    padding: 0.5rem 0;
}

.reset-dialog-actions {
    gap: 10px;
    padding-top: 0.5rem;
    border-top: 1px solid #e9ecef;
}

.reset-btn-primary {
    background-color: #007bff;
    border: 1px solid #007bff;
    color: white;
    padding: 0.5rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.reset-btn-primary:hover {
    background-color: #0069d9;
    border-color: #0062cc;
    color: white;
}

.reset-btn-secondary {
    background-color: #6c757d;
    border: 1px solid #6c757d;
    color: white;
    padding: 0.5rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.reset-btn-secondary:hover {
    background-color: #5a6268;
    border-color: #545b62;
    color: white;
}

/* Spinner para loading */
.spinner-border {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    vertical-align: text-bottom;
    border: 0.2em solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
    to { transform: rotate(360deg); }
}

/* Responsive */
@media (max-width: 768px) {
    .reset-input {
        font-size: 0.9rem;
        padding: 0.4rem 0.6rem;
    }

    .password-policy-item {
        font-size: 0.85rem;
    }

    .reset-btn-primary {
        width: 100%;
        padding: 0.5rem;
        min-width: unset;
    }

    .reset-dialog-actions {
        flex-direction: column;
    }

    .reset-dialog-actions .b-button {
        width: 100%;
    }
}

@media (max-width: 576px) {
    .password-policy-title {
        font-size: 0.95rem;
    }

    .reset-input {
        font-size: 0.85rem;
        padding: 0.35rem 0.5rem;
    }

    .password-policy-item {
        font-size: 0.8rem;
    }
}
</style>